import { CSSProperties, FC, ReactNode } from "react";

const ListBlockMediaItem: FC<{
  title: string;
  subtitle?: ReactNode;
  media?: ReactNode;
  onClick?: () => void;
  wrap?: boolean;
  style?: CSSProperties;
}> = ({ subtitle, wrap, media, onClick, title, style }) => (
  <li className="item-content" style={style}>
    <div className="item-media">{media}</div>
    <div className="item-inner" onClick={onClick}>
      <div className="item-title-row">
        <div className="item-title">{title}</div>
        {subtitle && (
          <div className="item-subtitle" style={wrap ? { whiteSpace: "inherit" } : undefined}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  </li>
);

export default ListBlockMediaItem;
